import {
  fetchSelectSurvey,
  fetchSurveyList,
  fetchSurveyQuestions,
  fetchValidateSurvey,
  searchSurveyMembers,
  validateSurvey
} from "../../api";
import {YN} from "../../components/AppConstants";

export default {
  async FETCH_SURVEYS({commit}, params) {
    const response = await fetchSurveyList(params)
    if (response.code === '0000') {
      commit('SET_SURVEYS', response.data);
    }
    return response;
  },
  async FETCH_SELECT_SURVEY({commit}, surveyId) {
    const response = await fetchSelectSurvey(surveyId);
    if (response.code === '0000') {
      commit('SET_SELECT_SURVEY', response.data);
    }
    return response;
  },
  async FETCH_VALIDATE_YN({commit}, surveyMemberId) {
    const response = await fetchValidateSurvey(surveyMemberId);
    if (response.code === '0000') {
      commit('SET_VALIDATE_YN', YN.Y);
    }
    return response;
  },
  async FETCH_SURVEY_QUESTIONS({commit}, surveyId) {
    const response = await fetchSurveyQuestions(surveyId);
    if (response.code === '0000') {
      commit('SET_SURVEY_QUESTIONS', response.data);
    }
    return response;
  },
  async SELECT_GUEST_SURVEY({commit}, orderNo) {
    const response = await searchSurveyMembers(orderNo);
    if (response.code === '0000') {
      commit('SET_GUEST_SURVEY', response.data);
    }
    return response;
  },
  async FETCH_GUEST_VALIDATE_YN({commit}, surveyMemberId) {
    const response = await validateSurvey(surveyMemberId);
    if (response.code === '0000') {
      commit('SET_VALIDATE_YN', YN.Y);
    }
    return response;
  },
}



// WEBPACK FOOTER //
// ./src/store/survey/actions.js